<template>
  <ElConfigProvider size="default" :locale="locales[language]" :z-index="3000">
    <RouterView></RouterView>
  </ElConfigProvider>
</template>

<script setup lang="ts">
  import { useUserStore } from './store/modules/user'
  import zh from 'element-plus/es/locale/lang/zh-cn'
  import en from 'element-plus/es/locale/lang/en'
  import { systemUpgrade } from './utils/sys'

  import { setThemeTransitionClass } from './utils/theme/animation'
  import { checkStorageCompatibility } from './utils/storage'
  import { useWebSocket } from '@/composables/useWebSocket'

  const userStore = useUserStore()
  const { language } = storeToRefs(userStore)

  const locales = {
    zh: zh,
    en: en
  }

  const UPLOAD_URL = import.meta.env.VITE_SOCKET_URL

  // http → ws，https → wss
  const wsBase =
    (location.protocol === 'https:' ? 'wss://' : 'ws://') +
    UPLOAD_URL + '/api/ws'

  const ws = useWebSocket(wsBase)
  provide('ws', ws) // 子组件通过 inject('ws') 使用

  onBeforeMount(() => {
    setThemeTransitionClass(true)
  })

  onMounted(() => {
    // 检查存储兼容性
    checkStorageCompatibility()
    // 提升暗黑主题下页面刷新视觉体验
    setThemeTransitionClass(false)
    // 系统升级
    systemUpgrade()

    ws.connect()
  })
</script>

